export default [
  {
    title: 'Statistics',
    route: 'estadistica',
    icon: 'HomeIcon',
  },
  {
    header: 'Mi Liga',
  },
  {
    title: 'Calification',
    route: 'inscriptions',
    icon: 'AirplayIcon',
    action: 'read',
    resource: 'ACL',
    disabled: false,
  },
  {
    title: 'Technique',
    route: 'tecnica',
    icon: 'ClipboardIcon',
    disabled: false,
  },
  {
    title: ' Generador horarios',
    route: 'horarios',
    icon: 'ClipboardIcon',
    disabled: false,
  },
  {
    title: 'Sanctions',
    route: 'sanciones',
    icon: 'FrownIcon',
    disabled: false,
  },
  // {
  //   title: 'News',
  //   route: 'ui-colors',
  //   icon: 'TwitchIcon',
  // },
  {
    title: 'Treasury',
    route: 'tesoreria',
    icon: 'DollarSignIcon',
  },
  {
    title: 'User',
    route: 'users',
    icon: 'UserPlusIcon',
  },
  {
    title: 'News',
    route: 'news',
    icon: 'TrelloIcon',
  },
  {
    title: 'Configuration',
    route: 'configuration',
    icon: 'SettingsIcon',
  },
  {
    title: 'Mi Perfil',
    route: 'profile',
    icon: 'UserIcon',
  },
  {
    title: 'Arbitros',
    route: 'arbitros',
    icon: 'UsersIcon',
  },
  {
    title: 'Auditoria',
    route: 'logs',
    icon: 'AlertTriangleIcon',
  },
  {
    title: 'Centro de Ayuda',
    route: 'ayuda',
    icon: 'HelpCircleIcon',
  },
  // {
  //   title: 'Peticiones',
  //   route: 'peticiones',
  //   icon: 'EditIcon',
  // },
  {
    title: 'Control Reuniones',
    route: 'reuniones',
    icon: 'EditIcon',
  },
  // {
  //   title: 'Control Pagos',
  //   route: 'pagos',
  //   icon: 'ActivityIcon',
  // },
  // {
  //   title: 'Samantha',
  //   route: 'samantha',
  //   icon: 'ClipboardIcon',
  // },
]
